export const MAX_SCALE = 3;
export const MIN_SCALE = 0.01;
export const SCALE_BORDER = 50;
export const PAN_BORDER = 30;

export const MIN_DRAG_DIST = 5;
export const TRACKPAD_SCALE_MULTIPLIER = 0.02;
export const MOUSEWHEEL_SCALE_MULTIPLIER = 0.3;
export const POS_MULTIPLIER = 1;
export const PINCH_SCALE_MULTIPLIER = 0.007;
